export default function About() {
  return (
    <section id="what-we-do" className="py-20 lg:py-28 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16 lg:mb-20">
          <span className="text-primary text-sm font-semibold tracking-wider uppercase mb-3 block">
            Positioning
          </span>
          <h2 className="text-3xl lg:text-5xl font-display text-foreground mb-4 leading-tight">
            Built for Complex Operations
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed max-w-3xl mx-auto">
            BreakthruAI is not a software reseller. We are a systems architect — designing, building, and deploying intelligent automation tailored to how your organization actually operates.
          </p>
        </div>
      </div>
    </section>
  );
}